import React from 'react'

import { useTranslation } from 'react-i18next'

import AlertCard from '@components/myScores/MessagesView/AlertCard'
import { formatPriceInCents } from '@utils/formatters/number.formatter'

import type AccountAlert from '@models/AccountAlert'

interface Props {
  alert: AccountAlert
}

const PaymentProblemAccountAlert: React.FC<Props> = ({ alert }) => {
  const { t } = useTranslation()
  return (
    <AlertCard alert={alert}>
      <p className="text-lg mb-2.5">{t('content.paymentIsBeingProcessed')}</p>
      <p className="mb-2.5">
        {t('content.paymentProcessingAmount', {
          amount: formatPriceInCents(alert.amount ?? 0, { showDouble0ForCents: true }),
        })}
      </p>
    </AlertCard>
  )
}

export default PaymentProblemAccountAlert
